import { ProgramMethod } from "../types/program";
import { ComponentMethod } from "../types/component";

export const dummyCategories: any[] = [
    {
        name: 'Express Entry - French Proficiency',
        description: 'Express Entry - French Proficiency',
        draws: [],
        programs: [
            {
                name: "Express Entry - French Proficiency",
                description: "Express Entry - French Proficiency",
                active: true,
                method: ProgramMethod.AND,
                components: [
                    {
                        description: "Express Entry - French Proficiency",
                        method: ComponentMethod.AND,
                        program_functions: [
                            {
                                description: "Have French-language test results that show a minimum score of 7 in all 4 language abilities on the Niveaux de compétence linguistique canadiens",
                                parameters: [
                                    { description: "languages", value: "french" },
                                    { description: "tests", value: "tef, tcf" },
                                    { description: "min_speaking", value: "7" },
                                    { description: "min_listening", value: "7" },
                                    { description: "min_reading", value: "7" },
                                    { description: "min_writing", value: "7" }
                                ]
                            },
                        ]
                    },
                ],
            }
        ]
    },
    {
        name: 'Express Entry - French Proficiency',
        description: 'Express Entry - French Proficiency',
        draws: [],
        programs: [
            {
                name: "Express Entry - French Proficiency",
                description: "Express Entry - French Proficiency",
                active: true,
                method: ProgramMethod.AND,
                components: [
                    {
                        description: "Express Entry - French Proficiency",
                        method: ComponentMethod.AND,
                        program_functions: [
                            {
                                description: "Have French-language test results that show a minimum score of 7 in all 4 language abilities on the Niveaux de compétence linguistique canadiens",
                                parameters: [
                                    { description: "languages", value: "french" },
                                    { description: "tests", value: "tef, tcf" },
                                    { description: "min_speaking", value: "7" },
                                    { description: "min_listening", value: "7" },
                                    { description: "min_reading", value: "7" },
                                    { description: "min_writing", value: "7" }
                                ]
                            },
                        ]
                    },
                ],
            }
        ]
    },
    {
        name: 'Express Entry - French Proficiency',
        description: 'Express Entry - French Proficiency',
        draws: [],
        programs: [
            {
                name: "Express Entry - French Proficiency",
                description: "Express Entry - French Proficiency",
                active: true,
                method: ProgramMethod.AND,
                components: [
                    {
                        description: "Express Entry - French Proficiency",
                        method: ComponentMethod.AND,
                        program_functions: [
                            {
                                description: "Have French-language test results that show a minimum score of 7 in all 4 language abilities on the Niveaux de compétence linguistique canadiens",
                                parameters: [
                                    { description: "languages", value: "french" },
                                    { description: "tests", value: "tef, tcf" },
                                    { description: "min_speaking", value: "7" },
                                    { description: "min_listening", value: "7" },
                                    { description: "min_reading", value: "7" },
                                    { description: "min_writing", value: "7" }
                                ]
                            },
                        ]
                    },
                ],
            }
        ]
    },
    // Add more categories if needed
];

export const groups = [
    {
        key: "express-entry",
        value: "express-entry"
    },
    {
        key: "other-pr",
        value: "other-pr"
    },
    {
        key: "temporary",
        value: "temporary"
    },
]
